import React from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { GeniePadElementsSettingItem, SREV2 } from '../../../../api/pushGenie';
import { fetchAllVisits } from '../../../../pages/utils';
import { Actions } from '../../../../store/actions';
import { GlobalState } from '../../../../store/reducers';
import { PatientDetailsVisits } from '../../../../store/reducers/prescriptionPad';
import { getPxElementConfig, getSectionNameConfig } from '../../../../store/selectors/session';
import AppLoader from '../../../common/AppLoader';
import { PastVisitTable, Visits } from './PastVisits';
import { SectionNameConfig } from '../../../../store/db';
import { getAclViewClassName } from '../../../../restrictions/utils';

interface PatientDetailsPatientOverviewProps {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    padElementsConfig: GeniePadElementsSettingItem[];
    plId: string;
    onUseAsTemplate: (id: string) => void;
    sectionNameConfig?: SectionNameConfig;
}
type PatientDetailsPatientOverviewState = {
    visits: PatientDetailsVisits | undefined;
};
class PatientDetailsPatientOverview extends React.PureComponent<
    PatientDetailsPatientOverviewProps,
    PatientDetailsPatientOverviewState
> {
    state: PatientDetailsPatientOverviewState = {
        visits: undefined,
    };

    componentDidMount() {
        const { plId } = this.props;

        fetchAllVisits(plId)
            .then((response) => {
                if (response?.state === 'success' && response?.data) {
                    this.setState({
                        visits: response,
                    });
                }
            })
            .catch((e) => {
                console.error('patientDetailsPatientOverview=>', e);
            });
    }

    onCopy = (visit: Visits) => {
        const { onUseAsTemplate } = this.props;
        visit?.precriptionId && onUseAsTemplate(visit.precriptionId);
    };

    render() {
        const { visits } = this.state;
        const { padElementsConfig, dispatch, onUseAsTemplate, sectionNameConfig } = this.props;
        if (visits === undefined) {
            return (
                <div className="flex justify-center overflow-auto flex-col col-span-10 items-center w-full h-full">
                    <AppLoader />
                </div>
            );
        }

        return (
            <div className="flex justify-start overflow-auto flex-col col-span-10 items-start w-full h-full">
                <PastVisitTable
                    dispatch={dispatch}
                    visits={visits}
                    isIndividualElementCopyEnabled={false}
                    padElementsConfig={padElementsConfig}
                    sectionNameConfig={sectionNameConfig}
                    onCopy={this.onCopy}
                    aclClassForCopyCta={getAclViewClassName(SREV2.PT_DETAILS_VISIT_ACTIONS)}
                />
            </div>
        );
    }
}

export default connect((state: GlobalState) => ({
    padElementsConfig: getPxElementConfig(state),
    sectionNameConfig: getSectionNameConfig(state),
}))(PatientDetailsPatientOverview);
